import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from "date-fns";

export type WeekStartsOn = 0 | 1 | 2 | 3 | 4 | 5 | 6;

/** Returns the first and last day displayed by the month grid. */
export const getMonthGridRange = (month: Date, weekStartsOn: WeekStartsOn) => ({
  start: startOfWeek(startOfMonth(month), { weekStartsOn }),
  end: endOfWeek(endOfMonth(month), { weekStartsOn }),
});
